/* istanbul ignore file */
import { createTheme } from "@mui/material/styles";

export const createCustomizedTheme = ({
  actionItemColor,
  actionItemHoverColor,
}: {
  actionItemColor?: string;
  actionItemHoverColor?: string | null;
}) => {
  return createTheme({
    palette: {
      primary: {
        main: "#592C82",
      },
    },
    components: {
      MuiTabs: {
        styleOverrides: {
          flexContainer: {
            borderBottom: "1px solid #767676",
          },
          indicator: {
            height: "5px",
            backgroundColor: "#000",
          },
          root: {
            minHeight: "0",
          },
        },
      },
      MuiTab: {
        defaultProps: {
          disableRipple: true,
        },
        styleOverrides: {
          
          root: {
            fontFamily: "inherit",
            textTransform: "none",
            fontWeight: "600",
            fontSize: "18px",
            color: "#595959",
            padding: "11px 12px",
            minHeight: "0",
            "&.Mui-selected": {
              color: "#323232",
            },
            "&.Mui-focusVisible": {
              outline: "1px auto #592C82"
            }
          },
        },
      },
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            color: actionItemColor || "#006C7D",
            borderColor: actionItemColor || "#006C7D",
            margin: "0 8px 0 0",
            fontSize: "16px",
            padding: "4px 11px",
            border: "1px solid #006C7D",
            boxSizing: "border-box",
            "& i": {
              margin: "-5px 10px 0 -3px",
            },
            ":hover": {
              boxShadow: "none",
              backgroundColor: "transparent",
            },
            ":focus": {
              outline: "1px auto #592C82"
            }
          },
          contained: {
            backgroundColor: actionItemColor || "#006C7D",
            color: "#fff",
            boxShadow: "none",
            border: "1px solid #006C7D",
            boxSizing: "border-box",
            ":hover": {
              backgroundColor: actionItemHoverColor || "#006C7D",
              boxShadow: "none",
            },
          },
          outlined: {
            borderColor: actionItemColor || "#006C7D",
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            cursor: "pointer",
            textDecoration: "none",
            color: actionItemColor || "#006C7D",
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            padding: "8px 12px",
            border: "0!important",
            "&:focus": {
              outline: "1px auto #592C82"
            },
            ".errorOutline &": {
              outline: "1px auto #D80443"
            }

          },
          notchedOutline: {
            border: "1px solid #949494!important"
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            color: "#006C7D",
            margin: "0 0 7px 0",
          },
        },
      },
      MuiTable: {
        styleOverrides: {
          root: {
            "& .MuiTableCell-root": {
              fontSize: "12px",
            },
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            "& .MuiTableCell-root": {
              fontWeight: "600",
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: "7px",
            borderBottom: "1px solid #9A9A9A",
          },
        },
      },
      MuiPagination: {
        styleOverrides: {
          root: {
            marginTop: "30px",
          },
        },
      },
      MuiPaginationItem: {
        styleOverrides: {
          root: {
            margin: "0 -1px 0 0",
            border: "1px solid #c2c2c2",
            borderRadius: "0",
            height: "32px",
            color: "#006C7D",
            "&:hover": {
              backgroundColor: "#eee",
            },
            "&.Mui-selected, &.Mui-selected:hover": {
              backgroundColor: "#006C7D",
              color: "#fff",
              borderColor: "#008094",
              zIndex: "1",
            },
            "&.Mui-disabled": {
              opacity: "1",
              color: "#767676",
            },
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          popper: {
            "&[data-popper-placement*='right'] .MuiTooltip-arrow":{
              marginLeft: "-1.065em",
              height: "1.5em",
              width: "1.065em"
            }
          }
        }
      }
    },
  });
};
